export default __webpack_public_path__ + "static/media/telegram.a8796469.svg";